import { render } from "./NewFooterView.vue?vue&type=template&id=13be4c52&scoped=true"
import script from "./NewFooterView.vue?vue&type=script&lang=js"
export * from "./NewFooterView.vue?vue&type=script&lang=js"

import "./NewFooterView.vue?vue&type=style&index=0&id=13be4c52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13be4c52"]])

export default __exports__